/**
 * Keeping the caret where it is when a button is pressed.
 *
 * A press moves the focus to the button, which takes the caret out of the
 * editor and hides it, so the player has to click back into the text before
 * typing again. Refusing the press that would move the focus leaves the click
 * itself working, and the button is still reachable from the keyboard.
 */
export function holdCaret(event: MouseEvent): void {
  event.preventDefault();
}
